import React, { useState } from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import 'moment/locale/hy-am.js';
import user from "../../assets/img/userbig.png";
import {useSelector} from "react-redux";
import CustomLinesEllipsis from "../Mydata/CustomLinesEllipsis.js";
import DeleteNotification from "./DeleteNotification.js";

const NotificationItem = (props) => {
    const [show, setShow] = useState(false);
    const [deleteN, setDelete] = useState(0);
    const navigate = useNavigate();
    const employee = useSelector((state) => state.manager.employee);

    const dateTask = new Date(props.date);
    const dateNow = new Date();

    const handleDeleteClick = () => {
        setDelete(props.id)
        setShow(false);
    };

    return (
        <div className='recommendations-item card'>
            {show && (
                <div className='options'>
                    <p className='options-item' onClick={handleDeleteClick}>Ջնջել</p>
                </div>
            )}

            <div className='recommendations-item-cont' onClick={() => navigate(props.toLink)}>
                <div className='card-overflow'>
                    <div className='recommendations-item-top'>
                        <div className='recommendations-item-heading-icon'>
              <span
                  style={{
                      color: dateTask.getDate() === dateNow.getDate() ? "#fccb00" : props.color
                  }}
                  className='icon-Component-21--1'
              />
                            <div className='recommendations-item-heading'>{props.team}</div>
                        </div>
                    </div>

                    <div className='company-name'>{props.comapanyName}</div>

                    <div className='recommendations-item-text'>
                        <CustomLinesEllipsis text={props?.teamText} maxLines={2} />
                        <div className='recommendations-item-text-icon'>
                            {(props.imgList && props.imgList.length > 0) && <span className='icon-Attachment'/>}
                        </div>
                    </div>
                </div>

                <div className='recommendations-item-bottom'>
                    <hr />
                    <div className='image-calendar'>
                        <div className="accountant_image_list">
                            {props.image_list?.map((item, index) => (
                                <img
                                    key={index}
                                    className='accountant_image'
                                    src={item.image ? item.image : user}
                                    alt="user"
                                />
                            ))}
                        </div>
                        <div className='calendar'>
                            <span className='icon-Calendar'/>
                            <div className="task-date-cont">
                <span className='moment'>
                  {moment(props.date).format('LL')}
                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {localStorage.getItem("profession") === "manager"&& employee && props.manager === employee.url && (
                <span
                    className="icon-Options"
                    onClick={() => setShow(!show)}
                />
            )}
            {deleteN?<DeleteNotification open={deleteN} setOpen={setDelete} getData={props.getTaskData}/>:null }
        </div>
    );
};

export default NotificationItem;
